import styled from "styled-components";

export const StyleDataPicker = styled.div`
    width: 100%;
`